export default __webpack_public_path__ + "static/caseStudy1-fr-875f24f79ec5e41ee1b2a746e350586b.webp";